import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionGuard, WithoutPermissionGuard } from '@app/guards';
import { TrainingProgram } from '@models/training/training-program.model';
import { TrainingResolver } from '@training/training.resolver';
import { RecordShowView, TrainingProgramFormView, TrainingProgramRecordsView } from '@training/views';
import { RecordsIndexView } from '@training/views/training-program-records/index/records-index.view';
import { ProgramShowView } from '@training/views/training-programs/show/program-show.view';
import { TrainingProgramsView } from '@training/views/training-programs/training-programs.view';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'upcoming',
        pathMatch: 'full',
        data: {
            cannot: TrainingProgram.managePermission,
        },
    },
    {
        path: 'upcoming',
        component: RecordsIndexView,
        canActivate: [WithoutPermissionGuard],
        data: {
            cannot: [TrainingProgram.managePermission],
            withoutPermissionRedirectTo: ['/training', 'activity'],
        },
    },
    {
        path: 'complete',
        component: RecordsIndexView,
        data: {
            cannot: [TrainingProgram.managePermission],
            withoutPermissionRedirectTo: ['/training', 'activity'],
        },
    },
    {
        path: 'team-log',
        component: TrainingProgramRecordsView,
        canActivate: [PermissionGuard],
        data: {
            excludeSelf: true,
            canActivateRedirectTo: ['/training'],
            permission: ['manageDirectReports', 'manageDirectAndIndirectReports'],
        },
    },
    {
        path: 'log/:trainingProgramRecord',
        component: RecordShowView,
        resolve: {
            models: TrainingResolver,
        },
    },
    {
        path: 'programs',
        children: [
            {
                path: '',
                component: TrainingProgramsView,
                canActivate: [PermissionGuard],
                data: {
                    canActivateRedirectTo: ['/training'],
                    permission: TrainingProgram.managePermission,
                },
            },
            {
                path: 'new',
                component: TrainingProgramFormView,
                canActivate: [PermissionGuard],
                data: {
                    permission: TrainingProgram.managePermission,
                    canActivateRedirectTo: ['training'],
                },
            },
            {
                path: ':trainingProgram',
                component: ProgramShowView,
                canActivate: [PermissionGuard],
                data: {
                    canActivateRedirectTo: ['/training'],
                    permission: TrainingProgram.managePermission,
                },
                resolve: {
                    models: TrainingResolver,
                },
            },
            {
                path: ':trainingProgram/edit',
                component: TrainingProgramFormView,
                canActivate: [PermissionGuard],
                resolve: {
                    models: TrainingResolver,
                },
                data: {
                    permission: TrainingProgram.managePermission,
                    canActivateRedirectTo: ['training'],
                },
            },
        ],
    },
    {
        path: 'activity',
        component: TrainingProgramRecordsView,
        canActivate: [PermissionGuard],
        data: {
            canActivateRedirectTo: ['/training'],
            permission: TrainingProgram.managePermission,
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class TrainingRouterModule {}
